import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path d="M6 22c-1.6569 0-3-1.3431-3-3 0-.6.18-1.16.5-1.63L9 7.81V6c-.5523 0-1-.4477-1-1V4c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v1c0 .5523-.4477 1-1 1v1.81l5.5 9.56c.32.47.5 1.03.5 1.63 0 1.6569-1.3431 3-3 3zm-1-3c0 .5523.4477 1 1 1h12c.5523 0 1-.4477 1-1 0-.21-.07-.41-.18-.57l-2.29-3.96L14 17l-5.07-5.07-3.75 6.5c-.11.16-.18.36-.18.57m8-9c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1" />,
  'Flask',
);
